import { setStorageItem } from '@/utils/auth'

export default {
  SET_INFO_SELL(state, data) {
    if (typeof data == 'object') {
      if(data.orders != undefined){
        state.sell = data
        setStorageItem('SELL', JSON.stringify(data))
      }
    }
  },
  
  SET_ADD_SELL(state, item) {
    if (typeof item == 'object') {
      state.rmId = item.rm_id
      if (state.sell == null) {
        state.sell = {
          orders: [item],
          paymentChoose:[],
          enableInventory: false,
          activeNegativeInv: false
        }
      }else{
        const index = state.sell.orders.findIndex((e) => (e.rm_id === item.rm_id))
        if (index != -1) {
          state.sell.orders[index] = item
        } else {
          state.sell.orders.push(item)
        }
      }
      setStorageItem('SELL_RM_ID', JSON.stringify(state.rmId))
    }
  },

  SET_RM_ID(state, rmId) {
    state.rmId = rmId
    setStorageItem('SELL_RM_ID', JSON.stringify(state.rmId))
  },

  SET_REMOVE_SELL(state, index) {
    state.sell.orders.splice(index, 1)
  },
  SET_SAVE_SELL(state, data) {
    state.sellSave = data
    setStorageItem('SELL_SAVE', JSON.stringify(data))
  },
  SET_LOADING(state, data) {
    state.loading = data;
  },
  SET_CUSTOMER(state, data) {
    state.modalAddCustomer = data;
  }  
}
